import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { SelectwithImage } from "../../LeadsTabs/LeadTasks/TasksSidebar/SelectwithImage";
// import DatePicker from "react-datepicker";
import Select, { StylesConfig } from "react-select";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  useCreateUpdateProjectTasksMutation,
  useGetAllActiveUsersQuery,
  useLazyGetProjectTaskByIdQuery,
  useTaskTypeLookupQuery,
} from "../../../../services/EndPointsApis";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { DatePicker } from "antd";
import TextField from "../../../../core/common/textFields/TextField";

const ProjectTasksSidebar = ({
  activityTogglePopup,
  refetch,
  isEditing,
  projectLookups,
  selectedId,
  setActivityTogglePopup,
  setIsEditing,
}: any) => {
  const params = useParams();
  const ProjectId = params?.projectId;
  dayjs.extend(customParseFormat);
  //createUpdateContigency
  const [createUpdateTasks, { data, isError, error, isSuccess, isLoading }] =
    useCreateUpdateProjectTasksMutation();
  //Active Users
  const { data: getallActiveUsers, refetch: activeUsersRefetch } =
    useGetAllActiveUsersQuery("");
  //Get Project Task By Id
  const [triggerTaskById, { data: getTaskById }] =
    useLazyGetProjectTaskByIdQuery();
  // task status api
  const { data: getTasksStatus } = useTaskTypeLookupQuery("");

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  const initialValues = {
    taskId: 0,
    title: "",
    projectId: ProjectId,
    startDate: "",
    dueDate: "",
    lst_PriorityCode: {
      id: 0,
      value: "",
    },
    lst_ProjectTaskStatus: {
      id: 0,
      value: "",
    },
    lst_AssignedTo: {
      id: 0,
      value: "",
    },
    description: "",
  };
  const TeamSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    startDate: Yup.string().required("Start Date is required"),
    dueDate: Yup.string().required("Due Date is required"),
    lst_AssignedTo: Yup.object().shape({
      id: Yup.number()
        .typeError("Assigned To is required")
        .required("Assigned To is required")
        .min(1, "Assigned To is required"),
    }),
  });
  const formik = useFormik({
    validationSchema: TeamSchema,
    initialValues,
    onSubmit: (values) => {
      createUpdateTasks(values);
    },
  });

  const { resetForm } = formik;

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message);
      resetForm();
      setActivityTogglePopup(false);
      refetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = "Something went wrong";

      if (
        "data" in error &&
        error.data &&
        typeof error.data === "object" &&
        "message" in error.data
      ) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);


  useEffect(() => {
    if (selectedId && isEditing===true) {
      triggerTaskById({ TaskId: selectedId, projectId: ProjectId });
    }
  }, [selectedId, activityTogglePopup,isEditing]);

  useEffect(() => {
    if (getTaskById?.result && Object.keys(getTaskById?.result).length > 0) {
      // setUpdateId(getTaskById?.result?.leadProspectId);
      formik.setValues({ ...getTaskById.result });
      // setDisabledata(true)
    } else {
      // setUpdateId(0);
    }
  }, [getTaskById,activityTogglePopup]);

  const handleSubmit = () => {
    formik.handleSubmit();
  };
  const handledueDate = (date: Dayjs | null) => {
    // setSelectedFreshAptDate(date);
    formik.setFieldValue("dueDate", date ? date.format("YYYY-MM-DD") : null);
  };
  const handleStartDate = (date: Dayjs | null) => {
    // setSelectedFreshAptDate(date);
    formik.setFieldValue("startDate", date ? date.format("YYYY-MM-DD") : null);
  };

  const closeSidebar = () => {
    setActivityTogglePopup(false);
    refetch();
    setIsEditing(false)
  };

  useEffect(() => {
    if(isEditing===false ){
        resetForm()        
    }
  }, [isEditing,activityTogglePopup])
  
  return (
    <div
      className={
        activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"
      }
    >
      <div className="sidebar-layout">
        <div className="sidebar-header">
          <h4>{isEditing ? "Edit Task" : "Add Task"} </h4>
          <Link
            to="#"
            className="sidebar-close toggle-btn"
            onClick={closeSidebar}
          >
            <i className="ti ti-x" />
          </Link>
        </div>
        <div className="toggle-body">
          <div className="toggle-height">
            <div className="pro-create">
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <TextField
                      label="Title"
                      required
                      {...formik.getFieldProps("title")}
                    />
                  </div>
                  {formik.touched.title && formik.errors.title && (
                    <div className="error">{formik.errors.title}</div>
                  )}
                  <div className="col-md-12 mt-2">
                    <div className="form-wrap">
                      <label className="col-form-label">
                        Assigned To
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={getallActiveUsers?.result?.map(
                          (option: any) => ({
                            label: option?.userName,
                            value: option?.userId,
                          })
                        )}
                        value={
                          formik.values?.lst_AssignedTo
                            ? {
                                value: formik.values?.lst_AssignedTo?.id,
                                label:
                                  formik.values?.lst_AssignedTo?.value || "",
                              }
                            : null
                        }
                        // isDisabled={viewOnly}
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue(
                            "lst_AssignedTo.id",
                            selectedOption?.value
                          );
                          formik.setFieldValue(
                            "lst_AssignedTo.value",
                            selectedOption?.label
                          );
                        }}
                      />
                      {formik.touched.lst_AssignedTo &&
                        formik.errors.lst_AssignedTo?.id && (
                          <div className="error">
                            {formik.errors?.lst_AssignedTo?.id}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="col-form-label">
                      Start Date <span className="text-danger">*</span>
                    </label>
                    <div className="form-wrap icon-form">
                      <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker deals-details "
                        // selected={selectedFreshAptmentDate}
                        onChange={handleStartDate}
                        value={
                          formik.values?.startDate
                            ? dayjs(formik.values?.startDate, "YYYY-MM-DD")
                            : null
                        }
                        format="MMM-DD-YYYY"
                      />
                    </div>
                    {formik.touched.startDate && formik.errors.startDate && (
                      <div className="error">{formik.errors?.startDate}</div>
                    )}
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="col-form-label">
                      Due Date <span className="text-danger">*</span>
                    </label>
                    <div className="form-wrap icon-form">
                      <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker deals-details "
                        // selected={selectedFreshAptmentDate}
                        onChange={handledueDate}
                        value={
                          formik.values?.dueDate
                            ? dayjs(formik.values?.dueDate, "YYYY-MM-DD")
                            : null
                        }
                        format="MMM-DD-YYYY"
                      />
                    </div>
                    {formik.touched.dueDate && formik.errors.dueDate && (
                      <div className="error">{formik.errors?.dueDate}</div>
                    )}
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="col-form-label">Priority</label>
                    <Select
                      styles={customStyles}
                      className="select"
                      options={projectLookups?.result?.Lst_PriorityCode?.map(
                        (option: any) => ({
                          label: option?.value,
                          value: option?.id,
                        })
                      )}
                      value={
                        formik.values?.lst_PriorityCode
                          ? {
                              value: formik.values?.lst_PriorityCode?.id,
                              label:
                                formik.values?.lst_PriorityCode?.value || "",
                            }
                          : null
                      }
                      // isDisabled={viewOnly}
                      onChange={(selectedOption: any) => {
                        formik.setFieldValue(
                          "lst_PriorityCode.id",
                          selectedOption?.value
                        );
                        formik.setFieldValue(
                          "lst_PriorityCode.value",
                          selectedOption?.label
                        );
                      }}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="col-form-label">Status</label>
                    <Select
                      styles={customStyles}
                      className="select"
                      options={getTasksStatus?.result?.map((option: any) => ({
                        label: option?.value,
                        value: option?.id,
                      }))}
                      value={
                        formik.values?.lst_ProjectTaskStatus
                          ? {
                              value: formik.values?.lst_ProjectTaskStatus?.id,
                              label:
                                formik.values?.lst_ProjectTaskStatus?.value ||
                                "",
                            }
                          : null
                      }
                      // isDisabled={viewOnly}
                      onChange={(selectedOption: any) => {
                        formik.setFieldValue(
                          "lst_ProjectTaskStatus.id",
                          selectedOption?.value
                        );
                        formik.setFieldValue(
                          "lst_ProjectTaskStatus.value",
                          selectedOption?.label
                        );
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <TextField
                      label="Description"
                      {...formik.getFieldProps("description")}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="submit-button text-end">
              <button
                type="button"
                className="btn btn-light sidebar-close"
                onClick={closeSidebar}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                onClick={handleSubmit}
              >
                {isEditing ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectTasksSidebar;
